import React, { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  TextField,
  makeStyles,
  MenuItem,
  Grid,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
// import { useAlert } from "react-alert";
// import { auctionCreate } from "../../../adminModel/auctions";
import Color from "../../../utils/colors";
// import api from "../../../axios";
// import Api from "../../../Api";
// import axios from "axios";
// import S3 from 'react-aws-s3';

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTypography-h5": {
      color: Color.green,
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  avatar: {
    height: 100,
    width: 100,
  },
}));

const Create = ({ className, ...rest }) => {
  const classes = useStyles();
  //const alert = useAlert();
  const [loading, setLoading] = useState(false);
  // const [auctions, setAuctions] = useState("");
  // const [slug, setSlug] = useState("");
  // const [startDate, setStartDate] = useState("");
  // const [endDate, setEndDate] = useState("");
  // const [downloadUrl, setDownLoadUrl] = useState("");
  // const [typeAuctions, setTypeAuctions] = useState("");
  const [banner, setBanner] = useState("");
  //  const [cover, setCover] = useState("");

  const [values, setValues] = useState({
    set_name: "",
    date_start: "",
    time_start: "",
    date_end: "",
    time_end: "",
    cover_url: "",
    isShow: "",
    isLive: "",
    auctionStatus: "",
  });

  const handleChange = (e) => {
    if (e.target.name === "cover_url") {
      setBanner(e.target.files[0]);
      // }else if(e.target.name==="auction_cover"){
      //   setCover(e.target.files[0])
    } else {
      /// console.log({ ...values, [e.target.name]: e.target.value })
      setValues({ ...values, [e.target.name]: e.target.value });
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const auction_details = {
      set_name: values.set_name,
      date_start: values.date_start,
      time_start: values.time_start,
      date_end: values.date_end,
      time_end: values.time_end,
      isShow: values.isShow,
      isLive: values.isLive,
      auction_status: values.auctionStatus,
    };
    console.log("auction_details: ", auction_details);

    // let formData = new FormData();    //formdata object
    //   formData.append('auction', values.auctions);   //append the values with key, value pair
    //   formData.append('slug', values.auctions.replace(/ /g, "-"));
    //   formData.append('catalogUrl', banner);
    //   formData.append('downloadUrl', values.downloadUrl);
    //   formData.append('startDate', values.startDate);
    //   formData.append('endDate', values.endDate);
    //   formData.append('type', values.type_auctions);
    //   formData.append('isShow', false);
    //   formData.append('auction_status', "PENDING");
    //   const config = {
    //       headers: { 'content-type': 'multipart/form-data' }
    //   }

    // const res = await fetch(`${Api.request.URL}admin/auction`, {
    //     method: "POST",
    //     body: formData,
    // }).then((res) => res.json());
    // console.log(JSON.stringify(`${res.message}, status: ${res.status}`));

    // const formData = new FormData();
    // formData.append("file", data.file[0]);

    // api.post( `${Api.request.URL}admin/auction`, formData, config)
    //     .then(response => {
    //         console.log(response);
    //     })
    //     .catch(error => {
    //         console.log(error);
    //     });

    // axios({
    //   method: "post",
    //   url: `${Api.request.URL}admin/auction`,
    //   data: auction_details,
    //   headers: { "Content-Type": "multipart/form-data" },
    // })
    //   .then(function (response) {
    //     //handle success
    //     console.log(response);
    //   })
    //   .catch(function (response) {
    //     //handle error
    //     console.log(response);
    //   });
  };

  // var reader = new FileReader();
  // const url = reader.readAsDataURL(auction_banner);

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={4} md={6} xs={12}>
          {/* <Typography>Banner</Typography> */}
          <Card style={{ height: "300px" }}>
            <CardContent>
              <img
                alt="Awsome"
                src={
                  banner ? URL.createObjectURL(banner) : "/static/blank.jpeg"
                }
                style={{ width: "100%", height: "270px" }}
              />
            </CardContent>
          </Card>
        </Grid>

        <Grid item lg={8} md={6} xs={12}>
          <form
            onSubmit={handleFormSubmit}
            autoComplete="off"
            className={clsx(classes.root, className)}
            {...rest}
          >
            <Card>
              <CardHeader title="Data Entry" />
              <Divider />
              <CardContent>
                <Grid container spacing={4}>
                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label="Name"
                      name="auction_name"
                      value={values.set_name}
                      type="text"
                      
                      variant="outlined"
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      readOnly={true}
                      label="Decription"
                      name="auction_decription"
                      type="text"
                      onChange={handleChange}
                      value={values.cover_url}
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      
                      fullWidth
                      label="Cover Url"
                      name="cover_url"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      type="file"
                      variant="outlined"
                      // value={banner}
                      onChange={handleChange}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      
                      fullWidth
                      label="Start Date"
                      name="date_start"
                      type="date"
                      value={values.date_start}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <TextField
                      
                      fullWidth
                      label="Start Time"
                      name="time_start"
                      type="time"
                      value={values.time_start}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      
                      fullWidth
                      label="End Date"
                      name="date_end"
                      type="date"
                      value={values.date_end}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      
                      fullWidth
                      label="Time End"
                      name="time_end"
                      type="time"
                      value={values.time_end}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth={true}
                      select
                      name="isShow"
                      label="Show"
                      value={values.isShow}
                      onChange={handleChange}
                      variant="outlined"
                    >
                      <MenuItem key={1} value="Live">
                        Show
                      </MenuItem>
                      <MenuItem key={2} value="Online">
                        No
                      </MenuItem>
                    </TextField>
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth={true}
                      select
                      name="isLive"
                      label="Live"
                      value={values.isLive}
                      onChange={handleChange}
                      variant="outlined"
                    >
                      <MenuItem key={1} value="Live">
                        Live
                      </MenuItem>
                      <MenuItem key={2} value="Online">
                        Online
                      </MenuItem>
                    </TextField>
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth={true}
                      select
                      name="auctionStatus"
                      label="Live"
                      value={values.auctionStatus}
                      onChange={handleChange}
                      variant="outlined"
                    >


                      <MenuItem key={0} value="Live">
                      PREVIOUS  AUCTION
                      </MenuItem>
                      <MenuItem key={1} value="Online">
                      UPCOMING AUCTION
                      </MenuItem>
                      <MenuItem key={2} value="Online">
                      ONGOING AUCTION
                      </MenuItem>
                    </TextField>
                  </Grid>

                  {/* <Grid item md={6} xs={12}>
                    <TextField
                      fullWidth
                      label="Catalog Download"
                      name="catalog_download"
                      value={values.catalog_download}
                      onChange={handleChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />
                  </Grid> */}
                </Grid>
              </CardContent>
              <Divider />
              <Box display="flex" justifyContent="flex-end" p={2}>
                <Button
                  // disabled={disable}
                  // style={Api.Button_save}
                  variant="contained"
                  type="submit"
                >
                  Save Details
                </Button>
              </Box>
            </Card>
          </form>
        </Grid>
      </Grid>

      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

Create.propTypes = {
  className: PropTypes.string,
};

export default Create;
